/**
 * SkeletonScreen Component
 * Displays skeleton loading placeholders
 * 
 * Requirements: 15.2
 */

import './SkeletonScreen.css';

interface SkeletonProps {
  variant?: 'text' | 'rectangular' | 'circular';
  width?: string | number;
  height?: string | number;
  animation?: 'pulse' | 'wave' | 'none';
}

export function Skeleton({
  variant = 'text',
  width,
  height,
  animation = 'pulse',
}: SkeletonProps) {
  const style: React.CSSProperties = {
    width: typeof width === 'number' ? `${width}px` : width,
    height: typeof height === 'number' ? `${height}px` : height,
  };

  return (
    <div
      className={`skeleton skeleton-${variant} skeleton-${animation}`}
      style={style}
    />
  );
}

interface SkeletonResultsProps {
  count?: number;
}

export function SkeletonResults({ count = 3 }: SkeletonResultsProps) {
  return (
    <div className="skeleton-results">
      <Skeleton variant="text" width="60%" height={24} />
      <div className="skeleton-criteria-list">
        {Array.from({ length: count }).map((_, index) => (
          <div key={index} className="skeleton-criterion">
            <div className="skeleton-criterion-header">
              <Skeleton variant="text" width="40%" height={18} />
              <Skeleton variant="circular" width={32} height={32} />
            </div>
            <Skeleton variant="text" width="80%" height={16} />
            <Skeleton variant="rectangular" width="100%" height={8} />
          </div>
        ))}
      </div>
    </div>
  );
}

interface SkeletonVideoProps {}

export function SkeletonVideo({}: SkeletonVideoProps) {
  return (
    <div className="skeleton-video">
      <Skeleton variant="rectangular" width="100%" height="100%" animation="wave" />
      <div className="skeleton-video-overlay">
        <Skeleton variant="circular" width={64} height={64} />
        <Skeleton variant="text" width="50%" height={20} />
      </div>
    </div>
  );
}

export default Skeleton;
